import { useState } from "react";
import { toast } from "sonner";
import { aiEstraiUno, spiegaErrore } from "../lib/aiUpload";
import UploadAIDialog, { AIButton } from "./UploadAIDialog";

/**
 * Pulsante "Carica … con AI": apre il modale unificato e fa leggere il file in background (/api/ai/estrai-job → extract/{endpoint}).
 */
export function ExtractButton({ endpoint, onExtracted, label = "Carica documento con AI", testid = "extract-button", size = "sm", className = "" }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [prog, setProg] = useState(null);

  const onFile = async (file) => {
    setBusy(true); setProg(null);
    try {
      const data = await aiEstraiUno(`extract/${endpoint}`, file, { onProgress: setProg });
      onExtracted(data);
      toast.success("Dati estratti — verifica e completa i campi");
      setOpen(false);
    } catch (err) {
      toast.error(spiegaErrore(err));
    }
    setBusy(false); setProg(null);
  };

  return (
    <>
      <AIButton size={size} busy={busy} label={label} className={className} onClick={() => setOpen(true)} data-testid={testid} />
      <UploadAIDialog open={open} onOpenChange={setOpen} busy={busy} progresso={prog} onFile={onFile} titolo={label} />
    </>
  );
}
